import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";

const faqs = [
  {
    q: "Intervenez-vous vraiment à domicile ?",
    a: "Oui. Un technicien SLH PHONE se déplace à votre domicile ou à votre bureau, partout à Lyon et dans sa métropole, de 10h à 23h, 7 jours sur 7.",
  },
  {
    q: "Combien de temps dure une réparation ?",
    a: "La plupart des réparations (écran, batterie, connecteur de charge) sont réalisées en 1 heure environ, sur place, sous vos yeux.",
  },
  {
    q: "Le devis est-il vraiment gratuit ?",
    a: "Oui. Diagnostic et devis sont gratuits avant toute intervention, sans engagement. Vous ne payez que si vous acceptez la réparation.",
  },
  {
    q: "Quelles marques de téléphones réparez-vous ?",
    a: "iPhone, Samsung, Xiaomi, Google Pixel et la plupart des autres marques. Appelez-nous pour confirmer votre modèle.",
  },
  {
    q: "Ma réparation est-elle garantie ?",
    a: "Oui. Chaque réparation est couverte par une garantie de 3 mois, pièces et main d'œuvre.",
  },
  {
    q: "Le déplacement est-il facturé ?",
    a: "Non, le déplacement est offert.",
  },
  {
    q: "Mes données sont-elles conservées ?",
    a: "Vos données restent sur votre téléphone. Rien n'est réinitialisé sans votre accord et aucune copie n'est conservée après l'intervention.",
  },
  {
    q: "Quand est-ce que je paie ?",
    a: "Après la réparation, uniquement une fois votre téléphone testé et parfaitement fonctionnel.",
  },
];

export const Faq = () => {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" className="relative py-28 lg:py-40" data-testid="faq-section">
      <div className="max-w-4xl mx-auto px-6 lg:px-12">
        <motion.h2
          className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight uppercase text-zinc-950 mb-16"
        >
          Questions <span className="text-chrome">fréquentes</span>
        </motion.h2>

        <div className="border-t border-zinc-200">
          {faqs.map((faq, i) => (
            <motion.div
              key={i}
              className="border-b border-zinc-200"
              data-testid={`faq-item-${i}`}
            >
              <button
                onClick={() => setOpen(open === i ? -1 : i)}
                className="w-full flex items-center justify-between gap-6 py-6 text-left group"
                data-testid={`faq-question-${i}`}
                aria-expanded={open === i}
              >
                <span className={`font-display text-lg md:text-xl font-semibold tracking-tight transition-colors duration-300 ${open === i ? "text-[#0055FF]" : "text-zinc-900 group-hover:text-[#0055FF]"}`}>
                  {faq.q}
                </span>
                <Plus
                  className={`h-5 w-5 shrink-0 text-[#0055FF] transition-transform duration-300 ${open === i ? "rotate-45" : ""}`}
                  aria-hidden="true"
                />
              </button>
              <AnimatePresence initial={false}>
                {open === i && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: "auto", opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
                    className="overflow-hidden"
                  >
                    <p className="pb-6 text-base leading-relaxed font-light text-zinc-600" data-testid={`faq-answer-${i}`}>
                      {faq.a}
                    </p>
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
